'use strict';

// Interceptor added in to medApp (see med_app.js) to verify the user still has access to the company
medApp.factory('VerifyAccessHttpInterceptor', ['$q', '$rootScope', '$location', '$document', '$cookieStore', '$injector', 'CoreLocationService', function($q, $rootScope, $location, $document, $cookieStore, $injector, CoreLocationService) {
    var methods_to_check = ['POST', 'PUT', 'DELETE'];
    return {
        request: function(config) {
            var deferred = $q.defer();
            // // Only interested in POST, PUT, and DELETE
            // if( methods_to_check.indexOf(config.method) != -1 ) {
            //     var company = $injector.get('company'); // Doing it like this to avoid a circular dependency error
            //     var user = $injector.get('user');
            //     if (company.getId() != null && user.getId() != null) {
            //         company.canUserAccessCompany(company.getId(), user.getId()).then( function canUserAccessCompanySuccess(result) {
            //             if(String(result) == 'true') {
            //                 deferred.resolve(config);
            //             }
            //             else {
            //                 $injector.get('CoreUserService').logoutAccessRevoked();
            //                 // rejecting this causes errors in the caller, since we are refreshing the page and abandoning this request anyway, just ignore.
            //                 // deferred.reject(config);
            //             }
            //         });
            //     }
            //     else {
            //         deferred.resolve(config);
            //     }
            // }
            // else {
                deferred.resolve(config);
            // }
            return deferred.promise;
        }
    };
}]);